import Vue from "vue";
import moment from "moment";
Vue.config.productionTip = false;
Vue.prototype.$storeCommun = {
  DataId: {
    ProgrammeGef: 4096,
    ProgrammeGem: 4097,
    Oui: 4008,
    BrouillonCandidat: 3643,
    ComplementCandidat: 3646,
    DossierRetenu: 3662,
    BoursierFirsi: 3663,
    DossierNonRetenu: 3670,
    Maroc: 1002134,
    France: 1002072,
  },
  ReadOnly: false,
  DateAgeFratrie: null,
  AnneeRevenus : null,
  ListeSituationsFamiliale: [],
  NombreTuteurs: null,
  ListeFratrie: [],
  ListeAutresBourses: [],
  ListeAutresRevenus: [],
  AutreRevenuDto: {
    Supprimer: false,
    PersonneConcernee: 5024,
    FinancementPropriete: 5047,
    CandidatureBourse: null,
    CandidatureBourseFirsi: null,
    SituationFamiliale: null,
    IdCrypte: null,
    RevenuAgricole: null,
    RevenuLocatifNet: null,
    Dividendes: null,
    AutresRevenus: null,
    ProduitVenteBien: null,
    Heritage: null,
    AutresRevenusExceptionnels: null,
    NatureRevenus: null,
    NatureRevenusExceptionnels: null,
  },
  ItemLang: "lang00",
  MaskCodeMassar: "A#########",
  InfosCandidature: {
    IdCrypte: null,
    CandidatureBourse: null,
    CandidatureBourseFirsi: null,
    Contact: null,
    EtesVous: null,
    ChargeUnParent: null,
    ParentTuteurDivorceMultiple: [],
    ParentTuteurDivorce: null,
    ParentVeuf: null,
    VousEtes: null,
    RevenuNetMensuel: null,
    NbCompteBancaire: null,
    NumCompteMarocain: null,
    FraisUniversitaire: null,
    MontantFraisUniversitaire: null,
    CompteEpargne: null,
    MontantEpargne: null,
    ValeurImmobiliere: null,
    ValeurTotaleTitres: null,
    DepotsTermes: null,
    MontantDuCapital: null,
    ProprietaireDeBiensImmobiliersSecondaire: null,
  },
  ParseSituationFamilialeDto(dto) {
    if (dto) {
      var parents = {
        CandidatureBourseFirsi : dto.candidatureBourseFirsi,
        CandidatureBourseId: dto.candidatureBourseId,
        Index: dto.index,
        Supprimer: false,
        IdCrypte: dto.idCrypte,
        Parente: dto.parente,
        Tuteur: dto.tuteur,
        StatutParentTuteur: dto.statutParentTuteur,
        Nom: dto.nom,
        Prenom: dto.prenom,
        Civilite: dto.civilite,
        Nationalite: dto.nationalite,
        Cni: dto.cni,
        Tel: dto.tel,
        Email: dto.email,
        Adresse: dto.adresse,
        Pays: dto.pays,
        RegionMaroc: dto.regionMaroc,
        ProvinceMaroc: dto.provinceMaroc,
        RegionFrance: dto.regionFrance,
        DepartementFrance: dto.departementFrance,
        SituationPro: dto.situationPro,
        DateDepartRetraite: this.ConvertDateApiToDateVue(
          dto.dateDepartRetraite
        ),
        SecteurActivitePro: dto.secteurActivitePro,
        Profession: dto.profession,
        Employeur: dto.employeur,
        SecteurProfessionnelleRetraite : dto.secteurProfessionnelleRetraite,
        ProfessionRetraite : dto.professionRetraite,
        TypeOrganismeRetraite : dto.typeOrganismeRetraite,
        EmployeurRetraite : dto.employeurRetraite,
        SituationHandicap: dto.situationHandicap,
        NatureHandicap: dto.natureHandicap,
        Mutuelle: dto.mutuelle,
        TypeOrganisme: dto.typeOrganisme,
        LienParenteTuteur: dto.lienParenteTuteur,
        IdCrypteRevenus: dto.idCrypteRevenus,
        RevenuNetMensuelDeclare: dto.revenuNetMensuelDeclare, // 8808
        RevenuNetMensuelDgi: dto.revenuNetMensuelDgi, // 8818
        RniAnnuelAttestationDGI: dto.rniAnnuelAttestationDGI, // 8809
        RnmAttestationSalaire: dto.rnmAttestationSalaire, // 8811
        RevenuNetAnnuelAttestation: dto.revenuNetAnnuelAttestation, // 8810
        RnmDernierBp: dto.rnmDernierBp, // 8812
        RnmBulletinPaieDec: dto.rnmBulletinPaieDec, // 8813
        RnmAutre: dto.rnmAutre, // 8814
        SommeRnmPensionsPercues: dto.sommeRnmPensionsPercues, // 8815
        AllocationsFamiliales: dto.allocationsFamiliales, // 8816
        SommeRnmPensionsPercuesMere: dto.sommeRnmPensionsPercuesMere, // 8817
        ProfitsEtrangersCaHt: dto.profitsEtrangersCaHt,
        ProfitsEtrangersNetImposable: dto.profitsEtrangersNetImposable,
        ProfitsEtrangersEmployeur: dto.profitsEtrangersEmployeur,
        CapitauxMobiliersCaHt: dto.capitauxMobiliersCaHt,
        CapitauxMobiliersNetImposable: dto.capitauxMobiliersNetImposable,
        CapitauxMobiliersEmployeur: dto.capitauxMobiliersEmployeur,
        FonciersCaHt: dto.fonciersCaHt,
        FonciersNetImposable: dto.fonciersNetImposable,
        FonciersEmployeur: dto.fonciersEmployeur,
        SalariauxEtAssimilesCaHt: dto.salariauxEtAssimilesCaHt,
        SalariauxEtAssimilesNetImposable: dto.salariauxEtAssimilesNetImposable,
        SalariauxEtAssimilesEmployeur: dto.salariauxEtAssimilesEmployeur,
        AgricolesCaHt: dto.agricolesCaHt,
        AgricolesNetImposable: dto.agricolesNetImposable,
        AgricolesEmployeur: dto.agricolesEmployeur,
        ProfessionnelsCaHt: dto.professionnelsCaHt,
        ProfessionnelsNetImposable: dto.professionnelsNetImposable,
        ProfessionnelsEmployeur: dto.professionnelsEmployeur,
        TelFixe: dto.telFixe,
        AdressePermanente: dto.adressePermanente,
        AdresseSecondaire: dto.adresseSecondaire,
        AmoTadamon: dto.amoTadamon,
        AutreRegime: dto.autreRegime,
        NomAutreRegime: dto.nomAutreRegime,
        SituationASaisir: dto.situationASaisir,
        BienImmoSecondaireParentsTuteurs: dto.bienImmoSecondaireParentsTuteurs,
        NombreCompteBancaire: dto.nombreCompteBancaire,
        AssocieGerant: dto.associeGerant,
        PreciserSociete: dto.preciserSociete,
        ListeBiensImmo: [],
        ListeCredits: [],
        ListeAnnexesFirsi: [],
      };

      if (dto.autreRevenuDto) {
        parents.AutreRevenuDto = {
          Supprimer: false,
          PersonneConcernee: dto.autreRevenuDto.personneConcernee,
          FinancementPropriete: dto.autreRevenuDto.financementPropriete,
          CandidatureBourse: dto.autreRevenuDto.candidatureBourse,
          CandidatureBourseFirsi: dto.autreRevenuDto.candidatureBourseFirsi,
          SituationFamiliale: dto.autreRevenuDto.situationFamiliale,
          IdCrypte: dto.autreRevenuDto.idCrypte,
          RevenuAgricole: dto.autreRevenuDto.revenuAgricole,
          RevenuLocatifNet: dto.autreRevenuDto.revenuLocatifNet,
          Dividendes: dto.autreRevenuDto.dividendes,
          AutresRevenus: dto.autreRevenuDto.autresRevenus,
          ProduitVenteBien: dto.autreRevenuDto.produitVenteBien,
          Heritage: dto.autreRevenuDto.heritage,
          AutresRevenusExceptionnels:
            dto.autreRevenuDto.autresRevenusExceptionnels,
          NatureRevenus: dto.autreRevenuDto.natureRevenus,
          NatureRevenusExceptionnels:
            dto.autreRevenuDto.natureRevenusExceptionnels,
        };
      }

      // Liste des autres revenus de la situation familiale
      if (dto.listeBiensImmo) {
        dto.listeBiensImmo.forEach((revenu) => {
          var revenuDto = {
            Supprimer: false,
            CandidatureBourse: revenu.candidatureBourse,
            SituationFamiliale: revenu.situationFamiliale,
            Adresse: revenu.adresse,
            Duree: revenu.duree,
            NombreBiens: revenu.nombreBiens,
            IdCrypte: revenu.idCrypte,
            MontantEcheance: revenu.montantEcheance,
            MontantGlobal: revenu.montantGlobal,
            Superficie: revenu.superficie,
            FinancementPropriete: revenu.financementPropriete,
            NatureBien: revenu.natureBien,
            PersonneConcernee: revenu.personneConcernee,
            TypeFinancement: revenu.typeFinancement,
            NumeroTitreFoncier: revenu.numeroTitreFoncier,
            DateAcquisition: revenu.dateAcquisition,
            ValeurAcquisition: revenu.valeurAcquisition,
            ValeurEstimative: revenu.valeurEstimative,
            SourceEstimation: revenu.sourceEstimation,
          };

          parents.ListeBiensImmo.push(revenuDto);
        });
      }

      if (dto.listeCredits) {
        dto.listeCredits.forEach((revenu) => {
          var revenuDto = {
            Supprimer: false,
            CandidatureBourse: revenu.candidatureBourse,
            SituationFamiliale: revenu.situationFamiliale,
            Adresse: revenu.adresse,
            Duree: revenu.duree,
            NombreBiens: revenu.nombreBiens,
            IdCrypte: revenu.idCrypte,
            MontantEcheance: revenu.montantEcheance,
            MontantGlobal: revenu.montantGlobal,
            Superficie: revenu.superficie,
            FinancementPropriete: revenu.financementPropriete,
            NatureBien: revenu.natureBien,
            PersonneConcernee: revenu.personneConcernee,
            TypeFinancement: revenu.typeFinancement,
          };

          parents.ListeCredits.push(revenuDto);
        });
      }

      return parents;
    }

    this.CountNombreTuteurs(this.ListeSituationsFamiliale);
  },
  ParseFratrieDto(dto) {
    let fratrie = {
      Index: dto.index,
      Supprimer: false,
      IdCrypte: dto.idCrypte,
      Nom: dto.nom,
      Prenom: dto.prenom,
      DateNaissance: this.ConvertDateApiToDateVue(dto.dateNaissance),
      SituationHandicap: dto.situationHandicap,
      NatureHandicap: dto.natureHandicap,
      NomPrenomPere: dto.nomPrenomPere,
      NomPrenomMere: dto.nomPrenomMere,
      ListeAnnexesFirsi: [],
    };

    return fratrie;
  },
  ParseBourseDto(dto) {
    let bourse = {
      Supprimer: false,
      IdCrypte: dto.idCrypte,
      Organisme: dto.organisme,
      Debut: this.ConvertDateApiToDateVue(dto.debut),
      Fin: this.ConvertDateApiToDateVue(dto.fin),
      MontantDirham: dto.montantDirham,
    };

    return bourse;
  },
  ParseInfosCandidature(dto) {
    this.InfosCandidature = {
      CandidatureBourseFirsi: dto.candidatureBourseFirsi,
      RegimeProtectionSociale: dto.regimeProtectionSociale,
      NomOrganisme: dto.nomOrganisme,
      IdCrypte: dto.idCrypte,
      CandidatureBourse: dto.candidatureBourse,
      Contact: dto.contact,
      EtesVous: dto.etesVous,
      ChargeUnParent: dto.chargeUnParent,
      ParentTuteurDivorce: dto.parentTuteurDivorce,
      ParentTuteurDivorceMultiple: dto.parentTuteurDivorceMultiple,
      ParentVeuf: dto.parentVeuf,
      VousEtes: dto.vousEtes,
      RevenuNetMensuel: dto.revenuNetMensuel,
      NbCompteBancaire: dto.nbCompteBancaire,
      NumCompteMarocain: dto.numCompteMarocain,
      FraisUniversitaire: dto.fraisUniversitaire,
      MontantFraisUniversitaire: dto.montantFraisUniversitaire,
      CompteEpargne: dto.compteEpargne,
      MontantEpargne: dto.montantEpargne,
      ValeurImmobiliere: dto.valeurImmobiliere,
      ValeurTotaleTitres: dto.valeurTotaleTitres,
      DepotsTermes: dto.depotsTermes,
      MontantDuCapital: dto.montantDuCapital,
      ConnaissanceFirsi: dto.connaissanceFirsi,
      PreciserConnaissance: dto.preciserConnaissance,
      ProprietaireDeBiensImmobiliersSecondaire:
        dto.proprietaireDeBiensImmobiliersSecondaire,
    };
  },
  ParseAutreRevenu(dto) {
    if (dto) {
      let revenu = {
        Supprimer: false,
        PersonneConcernee: dto.personneConcernee,
        FinancementPropriete: dto.financementPropriete,
        CandidatureBourse: dto.candidatureBourse,
        CandidatureBourseFirsi: dto.candidatureBourseFirsi,
        SituationFamiliale: dto.situationFamiliale,
        IdCrypte: dto.idCrypte,
        Adresse: dto.adresse,
        Duree: dto.duree,
        NombreBiens: dto.nombreBiens,
        MontantEcheance: dto.montantEcheance,
        MontantGlobal: dto.montantGlobal,
        Superficie: dto.superficie,
        NatureBien: dto.natureBien,
        TypeFinancement: dto.typeFinancement,
        NumeroTitreFoncier: dto.numeroTitreFoncier,
        DateAcquisition: dto.dateAcquisition,
        ValeurAcquisition: dto.valeurAcquisition,
        ValeurEstimative: dto.valeurEstimative,
        SourceEstimation: dto.sourceEstimation,
      };

      return revenu;
    }
  },
  ParseAutresRevenusDto(dto) {
    this.AutreRevenuDto = {
      Supprimer: false,
      PersonneConcernee: dto.personneConcernee,
      FinancementPropriete: dto.financementPropriete,
      CandidatureBourse: dto.candidatureBourse,
      SituationFamiliale: dto.situationFamiliale,
      IdCrypte: dto.idCrypte,
      RevenuAgricole: dto.revenuAgricole,
      RevenuLocatifNet: dto.revenuLocatifNet,
      Dividendes: dto.dividendes,
      AutresRevenus: dto.autresRevenus,
      ProduitVenteBien: dto.produitVenteBien,
      Heritage: dto.heritage,
      AutresRevenusExceptionnels: dto.autresRevenusExceptionnels,
      NatureRevenus: dto.natureRevenus,
      NatureRevenusExceptionnels: dto.natureRevenusExceptionnels,
    };
  },
  ConvertDateApiToDateVue(dateApi) {
    if (dateApi) {
      return moment(dateApi, "YYYY-MM-DD[T]hh:mm:ss").format("YYYY-MM-DD");
    } else {
      return null;
    }
  },
  CountNombreTuteurs(liste) {
    this.NombreTuteurs = liste.filter((item) => {
      return item.Supprimer == false && item.Tuteur == this.DataId.Oui;
    }).length;
  },
  // Afficher l'annexe
  AfficherAnnexe(urlFile) {
    if(urlFile){
      window.open(urlFile, "_blank");
    }
  },
  // Ajoute une ligne par défaut au tableau si la question == oui.
  QuestionTableau(question, tableau, element){
    if(question && tableau){
      if(question === this.DataId.Oui
        && tableau.length < 1
      ){
        tableau.push(Object.assign({},element));
      }
      else{
        tableau.splice(0);
      }
    }
  },
  NombreTuteurParente(parente, tuteur){
    return this.ListeSituationsFamiliale.filter(
          (item) => {
            return (
              item.Supprimer == false &&
              item.Tuteur == tuteur &&
              item.Parente == parente
            );
          }
        ).length;
  },

  NombreParentParStatutParentTuteur(statut, tuteur){
    return this.ListeSituationsFamiliale.filter(
          (item) => {
            return (
              item.Supprimer == false &&
              item.Tuteur == tuteur &&
              item.StatutParentTuteur == statut
            );
          }
        ).length;
  }
};
